module.exports = __webpack_public_path__ + "static/media/Vaishnavi.67c6bcaf.jpg";